<div class="table-container">
    <table class="data full-width image-type-table">
        <thead>
            <tr>
                <th>Device</th>
                <th>Image Type</th>
                <th>Action</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngIf="!uiDevices.length">
                <td colspan="1000">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
            </tr>
            <tr *ngFor="let d of uiDevices">
                <td class="device-col">
                    {{ d.name }}
                </td>
                <td class="type-col">
                    <mat-radio-group [(ngModel)]="d._selectedExtension" (change)="updateTimeline(d)">
                        <mat-radio-button value="tif" color="primary">TIFF</mat-radio-button>
                        <mat-radio-button value="jpg" color="primary">JPG</mat-radio-button>
                    </mat-radio-group>
                </td>
                <td class="action-col">
                    <button mat-raised-button color="primary" [disabled]="d._saveDisabled" (click)="saveSettings(d)">
                        Save
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>